import {createAsyncThunk, current} from "@reduxjs/toolkit";
import {isNullOrUndefined, PEV} from "../../../common/utils";
import * as service from "./service";

export const getUserGroupDetails = createAsyncThunk(
    "userGroupDetail/get",
    async (userGroupUniqueName, {rejectWithValue}) => {
      try {
        return await service.getUserGroupDetails(userGroupUniqueName);
      } catch (error) {
        let errorResponse = error?.response?.data?.errors;
        if (isNullOrUndefined(errorResponse)) {
          errorResponse = [{errorKey: "REQUEST_FAILED", errorMessage: "Request failed"}];
        }
        return rejectWithValue(errorResponse);
      }
    }
);

export const patchExcludedMembers = createAsyncThunk(
  "userGroupMemberExclude/patch",
  async (param, {rejectWithValue}) => {
    try {
      return await service.patchExcludedMembers(param.userGroupUniqueName, param.excludeMemberRequest);
    } catch (error) {
      let errorResponse = error?.response?.data;
      if (isNullOrUndefined(errorResponse)) {
        errorResponse = {errors: [{errorMessage: "Request failed"}]};
      }
      return rejectWithValue(errorResponse);
    }
  }
);

export const getUserGroupDetailsExtraReducers = {
  [getUserGroupDetails.pending.type]: (state, action) => {
    const userGroupUniqueName = action.meta.arg;
    state.userGroupDetails[userGroupUniqueName] = PEV({}, "Fetching user group detail");
  },
  [getUserGroupDetails.fulfilled.type]: (state, action) => {
    let userGroupDetail = {...action.payload};
    userGroupDetail.scope = current(state).userGroupScopeList.value.find(x => x.userGroupId === userGroupDetail.id)?.scope ?? null;
    const userGroupUniqueName = action.meta.arg;
    state.userGroupDetails[userGroupUniqueName] = PEV(userGroupDetail);
  },
  [getUserGroupDetails.rejected.type]: (state, action) => {
    const userGroupUniqueName = action.meta.arg;
    state.userGroupDetails[userGroupUniqueName] = PEV(
      {},
      null,
        action.payload
    );
  },
  [patchExcludedMembers.fulfilled.type]: (state, action) => {
    const updatedUserGroup = action.payload;
    state.userGroupDetails[updatedUserGroup.uniqueName] = PEV({
      ...state.userGroupDetails[updatedUserGroup.uniqueName].value,
      excludedMembers: updatedUserGroup.excludedMembers
    })
  },
};

export function userGroupDetailsTabStateManagement(state, userGroupId, activeTab) {
  if (!(userGroupId in state.userGroupDetailsTabStates)) {
    state.userGroupDetailsTabStates[userGroupId] = {};
  }
  state.userGroupDetailsTabStates[userGroupId] = {
    ...state.userGroupDetailsTabStates[userGroupId],
    activeTab,
  };
}

export const userGroupDetailsTabTypes = {
  Info: "Info",
  Members: "View Members",
  MembershipConditions: "Manage Members",
  AccessVisibility: "Access Visibility",
};

export const areMembersAvailableQueryParam = "areMembersAvailable";
export const fromTabQueryParam = "fromTab";
